import { render, staticRenderFns } from "./SignEventManageModal.vue?vue&type=template&id=58313a1c&"
import script from "./SignEventManageModal.vue?vue&type=script&lang=js&"
export * from "./SignEventManageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports